<template>
  <!-- 综合运行监控 -->
  <div class="app-container">
    <div class="title-container">
      <span class="runDays"> 安全运行 {{ monitorData.runDays }} 天</span>
      {{ monitorData.iotPlatformName }}
      <span class="time">{{ timeStr }}</span>
    </div>
    <div class="content-container clearfix">
      <div class="left-container">
        <div class="top-container clearfix">
          <div class="left-container">
            <div class="title">
              设备运行状态
            </div>
            <div class="state-container clearfix">
              <div
                class="state-item clearfix"
                @mouseenter="mouseEnter(index)"
                :class="{ error: item.status == 1, active: index == activeIdx }"
                v-for="(item, index) in monitorData.equipRoomItems"
                @click="viewItem(item.id)"
                :key="item.id"
              >
                <div class="equip-info">
                  <div class="equip-name">{{ item.name }}</div>
                  <div class="equip-state">
                    <span class="count">{{ item.countEquipNum }}</span
                    >全部 <span class="count">{{ item.countOnlineNum }}</span
                    >在线 <span class="count">{{ item.countOfflineNum }}</span
                    >离线
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="right-containerOur">
            <div class="right-container">
              <div class="title"></div>
              <div class="statistical-container">
                <div class="top-container clearfix">
                  <div
                    class="device-item"
                    v-for="(item, index) in deviceList"
                    :key="index"
                    @click="pageTo(index)"
                  >
                    <div
                      class="device-icon"
                      :style="
                        `background-image:url('/static/image/equip/device-item${index}.png')`
                      "
                    ></div>
                    <div class="device-tip">{{ item.label }}</div>
                    <div class="device-count">{{ item.count }}</div>
                  </div>
                </div>
                <div class="bottom-container clearfix">
                  <el-carousel
                    ref="carousel"
                    :interval="100000000"
                    trigger="click"
                    indicator-position="none"
                    @change="carouselChange"
                  >
                    <el-carousel-item
                      v-for="item in monitorData.equipRoomItems"
                      :key="item.equipId"
                    >
                      <div class="title clearfix">
                        <span class="fl">
                          <i class="square"></i>
                          {{ item.name }}
                          <i
                            class="circle"
                            :class="item.status == 1 ? 'error' : ''"
                          ></i>
                        </span>
                        <span class="fr"
                          ><b>在线：{{ item.countOnlineNum }}</b
                          ><b :class="item.countOfflineNum > 0 ? 'error' : ''"
                            >离线：{{ item.countOfflineNum }}</b
                          ></span
                        >
                      </div>
                      <div
                        class="detail clearfix"
                        :class="item.equipItems.length > 5 ? 'row2' : ''"
                      >
                        <span
                          v-for="(item1, index1) in item.equipItems"
                          :key="index1"
                          :title="item1.name"
                        >
                          <div :class="item1.status == 1 ? 'error' : ''">
                            {{ item1.status == 1 ? "异常" : "正常" }}
                          </div>
                          <div>{{ item1.name }}</div>
                        </span>
                      </div>
                      <div class="horizontal-line"></div>
                      <div class="title">
                        <span>
                          <i class="square"></i>
                          环境
                        </span>
                      </div>
                      <div class="detail wuhongwai mb10 clearfix">
                        <span
                          :class="{ 'filter-gray': item.esTemperature == -1 }"
                        >
                          <div>
                            {{
                              item.esTemperature == -1
                                ? "无"
                                : (item.esTemperature || 0) + "℃"
                            }}
                          </div>
                          <div>温度</div>
                        </span>
                        <span :class="{ 'filter-gray': item.esHumidity == -1 }">
                          <div>
                            {{
                              item.esHumidity == -1
                                ? "无"
                                : (item.esHumidity || 0) + "%RH"
                            }}
                          </div>
                          <div>湿度</div>
                        </span>
                        <span
                          :class="{
                            'filter-gray': item.esIntrusionStatus == -1
                          }"
                        >
                          <div :class="item.esWaterStatus == 1 ? 'error' : ''">
                            {{
                              item.esWaterStatus == 1
                                ? "异常"
                                : item.esWaterStatus == -1
                                ? "无"
                                : "正常"
                            }}
                          </div>
                          <div>水浸</div>
                        </span>
                        <span
                          :class="{
                            'filter-gray': item.esIntrusionStatus == -1
                          }"
                        >
                          <div :class="item.esSmokeStatus == 1 ? 'error' : ''">
                            {{
                              item.esSmokeStatus == 1
                                ? "异常"
                                : item.esSmokeStatus == -1
                                ? "无"
                                : "正常"
                            }}
                          </div>
                          <div>烟雾</div>
                        </span>
                        <!-- <span
                          :class="{
                            'filter-gray': item.esIntrusionStatus == -1
                          }"
                        >
                          <div
                            :class="item.esIntrusionStatus == 1 ? 'error' : ''"
                          >
                            {{
                              item.esIntrusionStatus == 1
                                ? "异常"
                                : item.esIntrusionStatus == -1
                                ? "无"
                                : "正常"
                            }}
                          </div>
                          <div>红外</div>
                        </span> -->
                      </div>
                      <div class="title">
                        <span>
                          <i class="square"></i>
                          24h内报警
                        </span>
                      </div>
                      <div class="fred" v-if="item.recentAlarm">
                        <div>{{ item.recentAlarm.content }}</div>
                        <div>
                          {{ item.recentAlarm.alertName
                          }}{{ item.recentAlarm.alarmValue
                          }}{{ item.recentAlarm.unit }}
                          <span>{{ item.recentAlarm.createTime }}</span>
                        </div>
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
            </div>
            <div class="right-container0">
              <div class="title">
                业务统计&nbsp;&nbsp;(7日)
              </div>
              <div class="statistical-container">
                <div class="bs clearfix" @click="pageTo('bs')">
                  <div>
                    <div class="bs-name"><i class="square"></i>报事</div>
                  </div>
                  <div class="bs-bt">
                    <div
                      id="echart-baoshi"
                      style="width: 50%;height: 100%;display: inline-block;"
                    ></div>
                    <div style="display: inline-block;width: 45%;height: 100%;">
                      <div style="margin-bottom: 10px;">
                        <div style="display: inline-block;">
                          <div class="echart-yuan zongdanshu-bg"></div>
                        </div>
                        <div
                          style="display: inline-block;color: #fff;font-size: 18px;margin-left: 5px;"
                        >
                          总单数
                        </div>
                        <div
                          style="display: inline-block;float: right;font-size: 18px;"
                        >
                          <span class="zongdanshu-color">{{
                            businessData.order ? businessData.order.total : 0
                          }}</span>
                          <span style="font-size: 12px;color: #fff;">单</span>
                        </div>
                      </div>
                      <div style="margin-bottom: 10px;">
                        <div style="display: inline-block;">
                          <div class="echart-yuan wanchengdanshu-bg"></div>
                        </div>
                        <div
                          style="display: inline-block;color: #fff;font-size: 18px;margin-left: 5px;"
                        >
                          完成单数
                        </div>
                        <div
                          style="display: inline-block;float: right;font-size: 18px;"
                        >
                          <span class="wanchengdanshu-color">{{
                            businessData.order
                              ? businessData.order.overTotal
                              : 0
                          }}</span>
                          <span style="font-size: 12px;color: #fff;">单</span>
                        </div>
                      </div>
                      <div style="margin-bottom: 10px;">
                        <div style="display: inline-block;">
                          <div class="echart-yuan zhixingzhong-bg"></div>
                        </div>
                        <div
                          style="display: inline-block;color: #fff;font-size: 18px;margin-left: 5px;"
                        >
                          执行中
                        </div>
                        <div
                          style="display: inline-block;float: right;font-size: 18px;"
                        >
                          <span class="zhixingzhong-color">{{
                            businessData.order ? businessData.order.inTotal : 0
                          }}</span>
                          <span style="font-size: 12px;color: #fff;">单</span>
                        </div>
                      </div>
                      <div>
                        <div style="display: inline-block;">
                          <div class="echart-yuan wanchenglv-bg"></div>
                        </div>
                        <div
                          style="display: inline-block;color: #fff;font-size: 18px;margin-left: 5px;"
                        >
                          完成率
                        </div>
                        <div
                          style="display: inline-block;float: right;font-size: 18px;"
                        >
                          <span class="wanchenglv-color">{{
                            businessData.order ? businessData.order.rate : 0
                          }}</span>
                          <span style="font-size: 12px;color: #fff;">%</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="xj clearfix" @click="pageTo('xj')">
                  <div>
                    <div class="xj-name"><i class="square"></i>巡检</div>
                  </div>
                  <div class="xj-bt">
                    <div
                      id="echart-xunjian"
                      style="width: 50%;height: 100%;display: inline-block;"
                    ></div>
                    <div style="display: inline-block;width: 45%;height: 100%;">
                      <div style="margin-bottom: 10px;">
                        <div style="display: inline-block;">
                          <div class="echart-yuan zongdanshu-bg"></div>
                        </div>
                        <div
                          style="display: inline-block;color: #fff;font-size: 18px;margin-left: 5px;"
                        >
                          总单数
                        </div>
                        <div
                          style="display: inline-block;float: right;font-size: 18px;"
                        >
                          <span class="zongdanshu-color">{{
                            businessData.report ? businessData.report.total : 0
                          }}</span>
                          <span style="font-size: 12px;color: #fff;">单</span>
                        </div>
                      </div>
                      <div style="margin-bottom: 10px;">
                        <div style="display: inline-block;">
                          <div class="echart-yuan wanchengdanshu-bg"></div>
                        </div>
                        <div
                          style="display: inline-block;color: #fff;font-size: 18px;margin-left: 5px;"
                        >
                          完成单数
                        </div>
                        <div
                          style="display: inline-block;float: right;font-size: 18px;"
                        >
                          <span class="wanchengdanshu-color">{{
                            businessData.report
                              ? businessData.report.overTotal
                              : 0
                          }}</span>
                          <span style="font-size: 12px;color: #fff;">单</span>
                        </div>
                      </div>
                      <div style="margin-bottom: 10px;">
                        <div style="display: inline-block;">
                          <div class="echart-yuan zhixingzhong-bg"></div>
                        </div>
                        <div
                          style="display: inline-block;color: #fff;font-size: 18px;margin-left: 5px;"
                        >
                          执行中
                        </div>
                        <div
                          style="display: inline-block;float: right;font-size: 18px;"
                        >
                          <span class="zhixingzhong-color">{{
                            businessData.report
                              ? businessData.report.inTotal
                              : 0
                          }}</span>
                          <span style="font-size: 12px;color: #fff;">单</span>
                        </div>
                      </div>
                      <div>
                        <div style="display: inline-block;">
                          <div class="echart-yuan wanchenglv-bg"></div>
                        </div>
                        <div
                          style="display: inline-block;color: #fff;font-size: 18px;margin-left: 5px;"
                        >
                          完成率
                        </div>
                        <div
                          style="display: inline-block;float: right;font-size: 18px;"
                        >
                          <span class="wanchenglv-color">{{
                            businessData.report ? businessData.report.rate : 0
                          }}</span>
                          <span style="font-size: 12px;color: #fff;">%</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="yf clearfix" @click="pageTo('yf')">
                  <div>
                    <div class="yf-name"><i class="square"></i>医废</div>
                  </div>

                  <div class="yf-cszl">
                    <div style="width: 55%;">
                      <span
                        style="color: #FFFFFF;font-size: 20px;margin-right: 21px;"
                        >产生量</span
                      >
                      <span style="color: #FAAA01;font-size: 30px;">
                        {{
                          businessData.medical
                            ? businessData.medical.weightKg
                            : 0
                        }}
                      </span>
                      <span style="color: #FFFFFF;font-size: 12px;">{{
                        businessData.medical &&
                          businessData.medical.weightKgDanwei
                      }}</span>
                    </div>
                    <div style="width: 44%;">
                      <span
                        style="color: #FFFFFF;font-size: 20px;margin-right: 21px;"
                        >袋数</span
                      >
                      <span style="color: #FAAA01;font-size: 30px;">
                        {{
                          businessData.medical ? businessData.medical.total : 0
                        }}
                      </span>
                      <span style="color: #FFFFFF;font-size: 12px;">{{
                        businessData.medical && businessData.medical.totalDanwei
                      }}</span>
                    </div>
                  </div>
                  <div class="yf-yczl">
                    <div style="width: 55%;">
                      <span
                        style="color: #FFFFFF;font-size: 20px;margin-right: 21px;"
                        >运出量</span
                      >
                      <span style="color: #FAAA01;font-size: 30px;">
                        {{
                          businessData.medical
                            ? businessData.medical.outWeightKg
                            : 0
                        }}
                      </span>
                      <span style="color: #FFFFFF;font-size: 12px;">{{
                        businessData.medical &&
                          businessData.medical.outWeightKgDanwei
                      }}</span>
                    </div>
                    <div style="width: 44%;">
                      <span
                        style="color: #FFFFFF;font-size: 20px;margin-right: 21px;"
                        >袋数</span
                      >
                      <span style="color: #FAAA01;font-size: 30px;">
                        {{
                          businessData.medical
                            ? businessData.medical.outTotal
                            : 0
                        }}
                      </span>
                      <span style="color: #FFFFFF;font-size: 12px;">{{
                        businessData.medical &&
                          businessData.medical.outTotalDanwei
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-container-yctj clearfix">
          <div class="title">异常统计</div>
          <div class="echart-container" id="echart-panel"></div>
        </div>
      </div>
      <div class="right-container">
        <div class="top-container-sbyxcs">
          <div class="title">电梯监控</div>
          <div class="table-container">
            <div class="top clearfix" @click="pageTo('dt')">
              <div class="elevator-monitoring">
                <div class="num-box">
                  <img
                    src="/static/image/equip/diantishuliang-icon.png"
                    alt=""
                  />
                  <div class="num-name">电梯数量</div>
                  <div class="num-number">{{ countVo.liftCount }}</div>
                </div>
                <div class="num-box">
                  <img
                    src="/static/image/equip/jiankongshuliang-icon.png"
                    alt=""
                  />
                  <div class="num-name">监控数量</div>
                  <div class="num-number">{{ countVo.cameraCount }}</div>
                </div>
                <div class="num-box">
                  <img
                    src="/static/image/equip/zaixianshuliang-icon.png"
                    alt=""
                  />
                  <div class="num-name">在线数量</div>
                  <div class="num-number">{{ countVo.cameraOnlineCount }}</div>
                </div>
              </div>
            </div>
            <div class="bottom clearfix">
              <div>
                <div class="bjxx-name"><i class="square"></i>报警信息</div>
              </div>
              <div
                id="list_dv"
                ref="forwardScrollBox"
                class="list_dv"
                @mouseenter="mouseenter"
                @mouseleave="mouseleave"
              >
                <div
                  style="position: relative;"
                  class="scrollD"
                  ref="forwardContent"
                >
                  <div
                    class="scroll1"
                    id="inner"
                    v-for="(item, index) in liftCameraAlarms"
                    :key="index"
                  >
                    <div style="width: 100%;">
                      <div
                        style="display: flex;height: 80%;padding: 10px;border-bottom: 1px solid #369aff;justify-content: space-between;"
                      >
                        <el-image
                          style="width: 21%;height: 58px;margin-right: 10px;"
                          :src="item.imgUrl"
                          alt=""
                        ></el-image>
                        <div style="width: 59%;">
                          <el-tooltip
                            class="item"
                            effect="dark"
                            :content="
                              item.buildingName +
                                '-' +
                                item.unitName +
                                '-' +
                                item.liftName
                            "
                            placement="top-start"
                          >
                            <div
                              style="font-weight: 600;font-size: 14px;color: #FFFFFE;margin-top: 7px;overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
                            >
                              {{
                                item.buildingName +
                                  "-" +
                                  item.unitName +
                                  "-" +
                                  item.liftName
                              }}
                            </div>
                          </el-tooltip>
                          <div style="margin-top: 12px;">
                            <!-- :style="
                                item.isHandle != 1
                                  ? 'color: #E86452'
                                  : 'color:#999999'
                              " -->

                            <span style="color: #FAAA01;">{{
                              item.event
                            }}</span>

                            <span
                              v-if="item.isHandle == 1"
                              style="color: #00A3FC;margin-left: 5px;"
                              >已处理</span
                            >
                            <span
                              v-else
                              style="color: #FF6666;margin-left: 5px;"
                              >未处理</span
                            >
                          </div>
                        </div>
                        <div style="height: 26px;display: inline-block;">
                          <el-button
                            style="border-radius:40px;background: linear-gradient(#022145, #00B7F5);border:  1px solid #369aff;"
                            type="primary"
                            @click="showWarnInfoDlg(item, '')"
                            >点击查看</el-button
                          >
                        </div>
                      </div>
                      <div
                        style="height: 20%;padding: 8px 11px;font-size: 14px;"
                      >
                        <div
                          style="display: flex; justify-content:space-between;"
                        >
                          <div>
                            <img
                              v-if="item.alarmLevelValue == '1'"
                              src="/static/image/equip/yijibaojing-icon.png"
                              alt=""
                              style="display: inline-block;"
                            />
                            <img
                              v-if="item.alarmLevelValue == '2'"
                              src="/static/image/equip/erjibaojing-icon.png"
                              alt=""
                              style="display: inline-block;"
                            />
                            <img
                              v-if="item.alarmLevelValue == '3'"
                              src="/static/image/equip/sanjibaojing-icon.png"
                              alt=""
                              style="display: inline-block;"
                            />
                            <span
                              v-if="item.alarmLevelValue == '1'"
                              style="display: inline-block;color: #00f6ff;"
                            >
                              {{ item.alarmLevelKey }}报警</span
                            >
                            <span
                              v-if="item.alarmLevelValue == '2'"
                              style="display: inline-block;color: #fa6501;"
                            >
                              {{ item.alarmLevelKey }}报警</span
                            >
                            <span
                              v-if="item.alarmLevelValue == '3'"
                              style="display: inline-block;color: #ff6666;"
                            >
                              {{ item.alarmLevelKey }}报警</span
                            >
                          </div>
                          <div>
                            <img
                              src="/static/image/equip/shijianriqi-icon.png"
                              alt=""
                              style="display: inline-block;"
                            />
                            <span style="color: #01D4F9;">
                              {{ item.createTime }}</span
                            >
                          </div>
                          <div>
                            <img
                              src="/static/image/equip/renyuan-icon.png"
                              alt=""
                              style="display: inline-block;"
                            />
                            <span style="color: #AED7FE;"
                              >人员:{{ item.personcount }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-container-bjts">
          <div class="title">报警提示</div>
          <div class="table-container">
            <el-table
              :data="alarmsData.abnormalAlarms"
              ref="alarmsTable"
              height="100%"
            >
              <el-table-column label="设备间" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.equipName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="名称" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.nodeName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="类型" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.alertName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="时间" align="center" width="150">
                <template slot-scope="scope">
                  <span>{{ scope.row.createTime }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="详情"
      :close-on-click-modal="false"
      :append-to-body="true"
      :visible.sync="zheDlg"
      width="1200px"
      top="30px"
      icon-class="el-icon-info"
    >
      <div class="table-container">
        <el-table
          ref="tableBar"
          class="m-small-table"
          height="500px"
          v-loading="listLoading"
          :key="tableKey"
          :data="dlgList"
          border
          fit
          highlight-current-row
          style="width: 100%;"
        >
          <el-table-column label="#" type="index" align="center" width="70">
            <template slot-scope="scope">
              <span>{{
                (listQuery.page - 1) * listQuery.limit + scope.$index + 1
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="楼宇">
            <template slot-scope="scope">
              <span>{{ scope.row.buildingName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="楼层">
            <template slot-scope="scope">
              <span>{{ scope.row.floor }}</span>
            </template>
          </el-table-column>
          <el-table-column label="环路名称">
            <template slot-scope="scope">
              <span>{{ scope.row.loopName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="点位名称">
            <template slot-scope="scope">
              <span>{{ scope.row.pointName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="温度(℃)">
            <template slot-scope="scope">
              <span>{{ scope.row.temperature }}</span>
            </template>
          </el-table-column>
          <el-table-column label="上报时间">
            <template slot-scope="scope">
              <span>{{ scope.row.reportTime }}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <pagination
          class="mt10"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="getDlgzhe"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="zheDlg = false" icon="el-icon-back">取消</el-button>
      </div>
    </el-dialog>

    <alarmDetailsDlg
      :dlgState0="dlgState"
      :dlgQuery="dlgQuery"
      :dlgType="dlgType"
      @closeDlg="closeDlg"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Cookie from "js-cookie";
import alarmDetailsDlg from "./components/alarmDetailsDlg.vue";
import Pagination from "@/components/Pagination"; // 分页
import { postAction, getAction } from "@/api";
// 接口
import {
  liftCameraCount, // 监控数量
  liftCameraAlarms,
  liftRunningLogs
} from "@/api/leftMan";
import * as echarts from "echarts";
import * as utils from "@/utils";
import {
  integratedOperationMonitoring,
  integratedAbnormalAlarms,
  reportInspectionMedical, //业务统计
  integratedATj, // 异常统计
  getBuildingCount, //楼宇数量
  projectTemp, //柱状图
  buildingTemp, //详情柱状图
  projectTempCount, //折线图
  projectTempPage, //详情折线图
  getSum, //饼图
  integratedABj // 异常趋势分析
} from "@/api/basicManSystem/comprehenOperateMonitor.js";
let echartPanelBing = null;
let echartPanelZhu = null;
let echartPanelDlgZhu = null;
let echartPanelZhe = null;
let echartPanelBaoshi = null;
let echartPanelXunjian = null;

let listQueryEmpty = {
  page: 1,
  limit: 20,
  projectId: "",
  startDate: "",
  compareStr: ""
};
export default {
  components: { Pagination, alarmDetailsDlg },
  data() {
    return {
      userInfo: JSON.parse(window.localStorage.userInfo),

      timeStr: utils.getTotime() + `(星期${utils.getWeek()})`,

      monitorData: {},

      alarmsData: {},

      exceptionData: {},

      businessData: {}, //业务统计

      echartPanel: null, // echart面板

      timer: null,

      tableTimer: null,

      deviceList: [],

      activeIdx: 0,
      buildingCount: "", //楼宇数量
      shanxingNum: "", //扇形显示

      echartAttendance: null,
      buildingArr: [],
      building: [],

      zheDlg: false,
      listQuery: JSON.parse(JSON.stringify(listQueryEmpty)),
      listLoading: false,
      total: 0,
      dlgList: [],
      tableKey: 0,
      dlgZheData: {},
      dlgZheType: "",
      interVal: null,

      countVo: {
        liftCount: 0,
        cameraCount: 0,
        cameraOnlineCount: 0
      },
      liftCameraAlarms: [],
      scrollHeight: "",
      forwardScrollBox: "",
      scrollContentHeight: 0, // 滚动内容的高度
      scrollBoxHeight: 0, // 滚动父级盒子的高度
      scrollableHeight: 0, // 可以滚动的高度
      scrollTop: 0, // 元素已经滚动的高度
      timer2: "", // 定时器
      dlgState: false,
      dlgQuery: {},
      dlgType: "",
      dlgState0: false,
      dlgQuery0: {}
    };
  },

  created() {
    this.getMonitor();
    this.getExceptionATj();
    this.getCount();
    this.getAlarms();
    this.$nextTick(() => {
      this.getLiftCameraCount();
      this.getLiftCameraAlarms();
      this.getbusiness();
      this.changeTime();
      this.scrollTable();
    });
  },

  mounted() {
    window.addEventListener("resize", e => {
      setTimeout(() => {
        if (!utils.isNull(this.echartPanel)) {
          this.echartPanel.resize();
        }
      }, 400);
    });
    if (this.interVal) {
      clearInterval(this.interVal);
    }
    this.interVal = setInterval(() => {
      this.getMonitor();
      this.getExceptionATj();
      this.getCount();
      this.getAlarms();
      this.$nextTick(() => {
        this.getLiftCameraCount();
        this.getLiftCameraAlarms();
        this.getbusiness();
        this.changeTime();
        this.scrollTable();
      });
    }, 300000);
  },

  beforeDestroy() {
    if (!utils.isNull(this.timer)) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (!utils.isNull(this.tableTimer)) {
      clearInterval(this.tableTimer);
      this.tableTimer = null;
    }
    if (!utils.isNull(this.interVal)) {
      clearInterval(this.interVal);
      this.interVal = null;
    }
  },

  methods: {
    //获取电梯监控数量
    getLiftCameraCount() {
      this.countVo.liftCount = 0;
      this.countVo.cameraCount = 0;
      this.countVo.cameraOnlineCount = 0;
      liftCameraCount(this.userInfo["projectId"]).then(res1 => {
        let res = res1.data;
        console.log(res, "res");
        if (res.code == "200") {
          this.countVo = JSON.parse(JSON.stringify(res.data));
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
    },
    //获取报警信息
    getLiftCameraAlarms() {
      if (this.interVal2) {
        clearInterval(this.interVal2);
      }
      if (this.timer2) {
        clearInterval(this.timer2);
      }
      liftCameraAlarms(this.userInfo["projectId"]).then(res1 => {
        let res = res1.data;
        if (res.code == "200") {
          this.liftCameraAlarms = JSON.parse(JSON.stringify(res.list));
          if (utils.isNull(this.liftCameraAlarms)) {
            this.liftCameraAlarms = [];
          }
          if (this.liftCameraAlarms && this.liftCameraAlarms.length > 0) {
            for (let index = 0; index < this.liftCameraAlarms.length; index++) {
              if (utils.isNull(this.liftCameraAlarms[index].unitName)) {
                this.liftCameraAlarms[index].unitName = "";
              }
            }

            //lh---每行列表的高度，speed---滚动的速度，delay---间隔多久滚动一次,marqueeDOM---需要实现这个效果的dom, overflowY--超出部分的高度
            this.$nextTick(() => {
              // listAutoScroll(169, 25, 1, forwardContent.value,20); // 方法调用
              this.regainHeight();
            });
          }
        } else {
          this.$message({
            type: "warning",
            message: res.msg
          });
        }
      });
    },
    regainHeight() {
      this.$nextTick(() => {
        let scrollHeight = document.getElementById("inner").scrollHeight + 10;
        // 获取需要滚动元素的真实高度
        // this.scrollContentHeight= forwardContent.value.getBoundingClientRect().height
        this.scrollContentHeight =
          scrollHeight * this.liftCameraAlarms.length + 10;
        // 获取限制高度滚动容器的真实高度
        this.scrollBoxHeight = this.$refs[
          "forwardScrollBox"
        ].getBoundingClientRect().height;
        // 可以滚动的高度
        this.scrollableHeight = this.scrollContentHeight - this.scrollBoxHeight;
        console.log(
          "内容高度",
          this.scrollContentHeight,
          "盒子高度",
          this.scrollBoxHeight,
          "可以滚动的高度",
          this.scrollableHeight
        );
        this.autoScroll();
      });
    },
    // 自动滚动
    autoScroll() {
      this.timer2 = setInterval(() => {
        if (this.scrollableHeight >= this.scrollTop) {
          // 当为滚动到结尾时滚动
          this.scrollTop = this.$refs["forwardScrollBox"].scrollTop += 1.5;
        } else {
          // 滚动结束，清除当前定时器，scrollTop重置为0，继续滚动
          this.scrollTop = this.$refs["forwardScrollBox"].scrollTop = 0;
          clearInterval(this.timer2);
          this.autoScroll();
        }
      }, 20);
    },
    // 鼠标移入时停止滚动
    mouseenter() {
      if (this.interVal2) {
        clearInterval(this.interVal2);
      }
      clearInterval(this.timer2);
    },
    // 鼠标移开继续滚动
    mouseleave() {
      this.interVal2 = setInterval(() => {
        // clearInterval(t.value);
        clearInterval(this.timer2);
        this.getLiftCameraCount();
        this.getLiftCameraAlarms();
        // getLiftRunningLogs(projectId)
        // initWebsocket(projectId)
      }, 60000);
      this.autoScroll();
    },
    closeDlg(type) {
      this.dlgState = false;
      if (type == "chuli") {
        this.getLiftCameraAlarms();
      }
    },
    showWarnInfoDlg(row, type, index0) {
      if (type == "btn") {
        row.id = row.alarmId;
      }
      this.openIndex = "";
      this.openIndex = index0;
      let isHandle = "";
      if (row.isHandle == 1) {
        this.dlgType = "info";
      } else {
        this.dlgType = "chuli";
      }
      this.dlgQuery = row;
      this.dlgState = true;
    },
    //获取业务统计
    getbusiness() {
      reportInspectionMedical().then(res => {
        let res0 = res.data;
        if (res0.code == 200) {
          if (res0.data.medical.outTotal >= 10000) {
            res0.data.medical.outTotal = (
              res0.data.medical.outTotal / 10000
            ).toFixed(2);
            res0.data.medical.outTotalDanwei = "万袋";
          } else {
            res0.data.medical.outTotalDanwei = "袋";
          }
          if (res0.data.medical.total >= 10000) {
            res0.data.medical.total = (res0.data.medical.total / 10000).toFixed(
              2
            );
            res0.data.medical.totalDanwei = "万袋";
          } else {
            res0.data.medical.totalDanwei = "袋";
          }
          if (res0.data.medical.outWeightKg >= 1000) {
            res0.data.medical.outWeightKg = (
              res0.data.medical.outWeightKg / 1000
            ).toFixed(2);
            res0.data.medical.outWeightKgDanwei = "吨";
          } else {
            res0.data.medical.outWeightKgDanwei = "千克";
          }
          if (res0.data.medical.weightKg >= 1000) {
            res0.data.medical.weightKg = (
              res0.data.medical.weightKg / 1000
            ).toFixed(2);
            res0.data.medical.weightKgDanwei = "吨";
          } else {
            res0.data.medical.weightKgDanwei = "千克";
          }
          this.businessData = res0.data;
          this.createChartBaoshi(res0.data);
          this.createChartXunjian(res0.data);
        } else {
          this.$message.error(res0.msg);
        }
      });
    },
    createChartBaoshi(data) {
      if (data.length <= 0) {
        if (!utils.isNull(echartPanelBaoshi)) {
          echartPanelBaoshi.clear();
        }
        return;
      }
      let seriesData = [
        { value: data.order.total, name: "总单数" },
        { value: data.order.overTotal, name: "完成单数" },
        { value: data.order.inTotal, name: "执行中" }
      ];
      echartPanelBaoshi = echarts.init(
        document.getElementById("echart-baoshi")
      );
      let option = {
        // itemStyle: {
        //   normal: {
        //     color: function(params) {
        //       var colorarrays = [
        //         "#0AFBBD",
        //         "#0AFBBD",
        //         // "#ffd886",
        //         // "#9F2E61",
        //         // "#4D670C"
        //       ];
        //       return colorarrays[params.dataIndex];
        //     }
        //   }
        // },
        color: ["#FAAA01", "#00A3FC", "#0AFBBD"],
        // color: ()=> {
        //       return (
        //         'rgb(' +
        //         [
        //           Math.round(Math.random() * 270),
        //           Math.round(Math.random() * 370),
        //           Math.round(Math.random() * 400)
        //         ].join(',') +
        //         ')'
        //       );
        //     },
        tooltip: {
          trigger: "item"
          // formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        // legend: {
        //   orient: "vertical",
        //   right: "20%",
        //   top: "50%",
        //   data: legendData,
        //   textStyle: {
        //     rich: {
        //       name: {
        //         // width: '45%',
        //         fontSize: 14,
        //         color: "#333333"
        //       },
        //       value: {
        //         fontSize: 16,
        //         padding: [0, 1, 0, 20],
        //         color: "#4C8AF6"
        //       }
        //     }
        //   },
        //   // formatter: function(name) {
        //   //   let res = seriesData.filter(v => v.buildingName === name);
        //   //   res = res[0] || {};
        //   //   const p = res.useWater;
        //   //   return "{name|" + name + "}" + "{value|" + p + "}";
        //   //   // return "{name|" + name + "}";
        //   // }
        // },
        title: {
          // text: `${clfsNum}`,
          // textStyle: {
          //   color: '#333333',
          //   fontSize: 42
          // },
          // itemGap: 10,
          // left: '34%',
          // top: '40%',
          // subtext: '总量',
          // subtextStyle: {
          //   color: '#333333',
          //   fontSize: 20,
          //   fontWeight: 'normal'
          // },
          textAlign: "center" // 主、副标题水平居中显示
        },
        grid: {
          top: "10%"
        },
        series: [
          {
            name: "",
            type: "pie",
            center: ["40%", "50%"],
            radius: ["100%", "60%"],
            avoidLabelOverlap: false,
            data: seriesData,
            labelLine: {
              show: false
            },
            label: {
              show: false
            }
          }
        ]
      };
      console.log(option, "option");
      echartPanelBaoshi.setOption(option);
    },
    createChartXunjian(data) {
      if (data.length <= 0) {
        if (!utils.isNull(echartPanelXunjian)) {
          echartPanelXunjian.clear();
        }
        return;
      }
      let seriesData = [
        { value: data.report.total, name: "总单数" },
        { value: data.report.overTotal, name: "完成单数" },
        { value: data.report.inTotal, name: "执行中" }
      ];
      echartPanelXunjian = echarts.init(
        document.getElementById("echart-xunjian")
      );
      let option = {
        // itemStyle: {
        //   normal: {
        //     color: function(params) {
        //       var colorarrays = [
        //         "#0AFBBD",
        //         "#0AFBBD",
        //         // "#ffd886",
        //         // "#9F2E61",
        //         // "#4D670C"
        //       ];
        //       return colorarrays[params.dataIndex];
        //     }
        //   }
        // },
        color: ["#0BFBBE", "#50CDFF", "#00A3FC"],
        // color: ()=> {
        //       return (
        //         'rgb(' +
        //         [
        //           Math.round(Math.random() * 270),
        //           Math.round(Math.random() * 370),
        //           Math.round(Math.random() * 400)
        //         ].join(',') +
        //         ')'
        //       );
        //     },
        tooltip: {
          trigger: "item"
          // formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        // legend: {
        //   orient: "vertical",
        //   right: "20%",
        //   top: "50%",
        //   data: legendData,
        //   textStyle: {
        //     rich: {
        //       name: {
        //         // width: '45%',
        //         fontSize: 14,
        //         color: "#333333"
        //       },
        //       value: {
        //         fontSize: 16,
        //         padding: [0, 1, 0, 20],
        //         color: "#4C8AF6"
        //       }
        //     }
        //   },
        //   // formatter: function(name) {
        //   //   let res = seriesData.filter(v => v.buildingName === name);
        //   //   res = res[0] || {};
        //   //   const p = res.useWater;
        //   //   return "{name|" + name + "}" + "{value|" + p + "}";
        //   //   // return "{name|" + name + "}";
        //   // }
        // },
        title: {
          // text: `${clfsNum}`,
          // textStyle: {
          //   color: '#333333',
          //   fontSize: 42
          // },
          // itemGap: 10,
          // left: '34%',
          // top: '40%',
          // subtext: '总量',
          // subtextStyle: {
          //   color: '#333333',
          //   fontSize: 20,
          //   fontWeight: 'normal'
          // },
          textAlign: "center" // 主、副标题水平居中显示
        },
        grid: {
          top: "10%"
        },
        series: [
          {
            name: "",
            type: "pie",
            center: ["40%", "50%"],
            radius: ["100%", "60%"],
            avoidLabelOverlap: false,
            data: seriesData,
            labelLine: {
              show: false
            },
            label: {
              show: false
            }
          }
        ]
      };
      console.log(option, "option");
      echartPanelXunjian.setOption(option);
    },

    // 幻灯片切换
    carouselChange(idx) {
      this.activeIdx = idx;
    },

    mouseEnter(idx) {
      this.activeIdx = idx;
      this.$refs.carousel.setActiveItem(idx);
    },

    // 创建图表
    createChart() {
      if (this.exceptionData.length == 0) {
        if (!utils.isNull(this.echartPanel)) {
          this.echartPanel.clear();
        }
        return;
      }
      let legendData = [];
      let xAxisData = [];
      let seriesData = [];
      for (let i of this.exceptionData) {
        legendData.push(i.name);
        xAxisData.push(i.name);
        seriesData.push(i.count);
      }
      // 基于准备好的dom，初始化echarts实例
      this.echartPanel = echarts.init(document.getElementById("echart-panel"));
      // 指定图表的配置项和数据
      let option = {
        color: function(params) {
          let colorList = [
            "#249CF9",
            "#EB6F49",
            "#FDB628",
            "#00E4EC",
            "#69FD28",
            "#C490BF",
            "#FFF100",
            "#486A00",
            "#F6B37F",
            "#7ECEF4",
            "#22AC38",
            "#7E6B5A"
          ];
          return colorList[params.dataIndex % colorList.length];
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        dataZoom: [
          {
            type: "inside"
          }
        ],
        grid: {
          left: "0",
          right: "2%",
          top: "10%",
          bottom: "2%",
          containLabel: true
        },
        legend: {
          data: legendData
        },
        xAxis: {
          type: "category",
          data: xAxisData,
          axisPointer: {
            type: "shadow"
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#5492ED",
              fontSize: "12"
            }
          },
          axisLine: {
            // 轴线
            lineStyle: {
              color: "#5492ED"
            }
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#5492ED",
              fontSize: "12"
            }
          },
          axisLine: {
            // 轴线
            lineStyle: {
              color: "#5492ED"
            }
          },
          splitLine: {
            // 轴上的分割线
            show: true,
            lineStyle: {
              // 设置分割线单独的样式
              color: "#5492ED"
            }
          }
        },
        series: [
          {
            type: "bar",
            barWidth: "30",
            data: seriesData,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "top"
                }
              }
            }
          }
        ]
      };

      this.echartPanel.setOption(option);
    },

    // 设置定时改变table
    scrollTable() {
      if (utils.isNull(this.tableTimer)) {
        let _this = this;
        this.tableTimer = setInterval(() => {
          let abnormalAlarms = _this.alarmsData.abnormalAlarms;
          let liftCameraAlarms = _this.liftCameraAlarms;
          // 报警提示 滚动
          if (abnormalAlarms && abnormalAlarms.length > 0) {
            let alarmsTable = _this.$refs.alarmsTable.$refs.bodyWrapper;
            // console.log(alarmsTable, "alarmsTable");
            let scrollTop = alarmsTable.scrollTop;
            scrollTop += 1;
            // 判断滚到到最后 重置0
            let clientHeight = alarmsTable.clientHeight;
            let scrollHeight = alarmsTable.scrollHeight;
            if (
              scrollHeight > clientHeight &&
              scrollTop + clientHeight >= scrollHeight
            ) {
              scrollTop = 0;
            }
            alarmsTable.scrollTop = scrollTop;
          }

          // 设备运行参数 滚动
          // if (equipRunParams && equipRunParams.length > 0) {
          //   let configTable = _this.$refs.configTable.$refs.bodyWrapper;
          //   let scrollTop = configTable.scrollTop;
          //   scrollTop += 1;
          //   // 判断滚到到最后 重置0
          //   let clientHeight = configTable.clientHeight;
          //   let scrollHeight = configTable.scrollHeight;
          //   if (
          //     scrollHeight > clientHeight &&
          //     scrollTop + clientHeight >= scrollHeight
          //   ) {
          //     scrollTop = 0;
          //   }
          //   configTable.scrollTop = scrollTop;
          // }
        }, 50);
      }
    },

    // 设置定时 改变时间
    changeTime() {
      if (utils.isNull(this.timer)) {
        let _this = this;
        this.timer = setInterval(() => {
          _this.timeStr = utils.getTotime() + `(星期${utils.getWeek()})`;
        }, 1000);
      }
    },

    // 获取数据
    getMonitor() {
      getAction(`/iot/integratedOperationMonitoring/v2?equipType=1`).then(
        res => {
          if (res.data.code == 200) {
            this.monitorData = res.data.data;
            this.deviceList = [
              {
                label: "总设备数",
                count: this.monitorData.countEquipNum
              },
              {
                label: "在线设备",
                count: this.monitorData.countOnlineNum
              },
              {
                label: "离线设备",
                count: this.monitorData.countOfflineNum
              },
              {
                label: "异常报警",
                count: this.monitorData.countAlarmNum
              },
              {
                label: "待处理",
                count: this.monitorData.waitForAlarmNum
              }
            ];
          } else {
            this.$message.error(res.data.msg);
          }
        }
      );
    },

    // 获取报警提示
    getAlarms() {
      this.alarmsData = "";
      getAction(`/iot/integratedAbnormalAlarms?equipType=1`).then(res => {
        if (res.data.code == 200) {
          this.alarmsData = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    // 获取异常统计
    getExceptionATj() {
      getAction(`/iot/integratedATj?equipType=1`).then(res => {
        if (res.data.code == 200) {
          this.exceptionData = res.data.data;
          this.$nextTick(() => {
            this.createChart();
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 获取项目楼宇数
    getCount() {
      getBuildingCount(this.userInfo.projectId).then(res => {
        if (res.data.code == 200) {
          this.buildingCount = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    dataF(oldArr) {
      let newArr = [];
      oldArr.forEach(item => {
        let obj = {
          date: item,
          temp: new Date(item).getTime()
        };
        newArr.push(obj);
      });

      let resultArr = newArr.sort(this.sortF);
      let targetArr = [];

      resultArr.forEach(item => {
        targetArr.push(item.date);
      });

      return targetArr;
      console.log(resultArr, "resultArr");
    },
    sortF(a, b) {
      return a.temp - b.temp;
    },

    showZheDlg(data, type) {
      this.zheDlg = true;
      this.dlgZheData = data;
      this.dlgZheType = type;
      this.getDlgzhe();
    },
    getDlgzhe() {
      if (this.dlgZheType == "高于阈值") {
        this.listQuery.compareStr = ">";
      } else {
        this.listQuery.compareStr = "<";
      }
      this.listQuery.projectId = this.userInfo.projectId;
      this.listQuery.startDate = this.dlgZheData.day;
      projectTempPage(this.listQuery).then(res1 => {
        let res = res1.data;
        console.log(res, "res");
        if (res.code == 200) {
          this.dlgList = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    // 跳转
    pageTo(idx) {
      if (idx < 2) {
        this.$router.push({ path: `/equipSafeMan/sensorEquip` });
      } else if (idx == 2) {
        this.$router.push({
          path: `/equipSafeMan/sensorEquip`,
          query: { state: "2" }
        });
      } else if (idx == 3) {
        this.$router.push({ path: `/equipSafeMan/abnormalAlarmGroup` });
      } else if (idx == 4) {
        this.$router.push({
          path: `/equipSafeMan/abnormalAlarmMan`,
          query: { status: "0" }
        });
      } else if (idx == "bs") {
        this.$router.push({
          path: `/matterMan/reportSuperviseNew`
        });
        window.sessionStorage.setItem("zhyxjk", "bs");
      } else if (idx == "xj") {
        this.$router.push({
          path: `/qualityMan/taskManNew`
        });
        window.sessionStorage.setItem("zhyxjk", "xj");
      } else if (idx == "yf") {
        this.$router.push({
          path: `/medicalWasteMan/comprehensiveDetailQuery`
        });
        window.sessionStorage.setItem("zhyxjk", "yf");
      } else if (idx == "dt") {
        this.$router.push({
          path: `/liftMan/realTimeMonitoring`
        });
      }
    },

    // 查看详情
    viewItem(id) {
      this.$router.push({ path: `/equipSafeMan/monitorDesc/${id}` });
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.app-container {
  background: url("/static/image/equip/bg.png") no-repeat center;
  background-size: cover;
  padding: 0 20px;
  .title-container {
    position: relative;
    height: 96px;
    line-height: 88px;
    text-align: center;
    color: #ffffff;
    font-size: 36px;
    font-weight: bold;
    background: url("/static/image/equip/top-bj@2x.png") no-repeat center;
    background-size: 100% 100%;
    .runDays {
      position: absolute;
      left: 0;
      width: 492px;
      margin-bottom: 0;
      font-size: 20px;
      padding-top: 6px;
      text-align: center;
    }
    .time {
      position: absolute;
      width: 30%;
      right: 0;
      font-size: 20px;
      padding-top: 6px;
    }
  }
  .content-container {
    height: calc(100% - 96px);
    overflow: hidden;
    .left-container {
      float: left;
      width: calc(76% + 20px);
      height: 100%;
      .top-container {
        height: 630px;
        margin-bottom: 10px;
        .left-container {
          float: left;
          width: 380px;
          height: 100%;
          .state-container {
            width: 100%;
            height: calc(100% - 30px);
            overflow-y: auto;
            scrollbar-width: none;
            .state-item {
              cursor: pointer;
              float: left;
              width: 187px;
              height: 70px;
              margin-right: 5px;
              margin-bottom: 5px;
              padding: 6px 0 0 12px;
              background: rgba(0, 186, 255, 0.1);
              border: 1px solid #369aff;
              &.error {
                background: rgba(254, 85, 85, 0.1);
                border: 1px solid #fe5555;
              }
              &.active {
                border: 1px solid #4f94e6;
                background: linear-gradient(to top, #3662a4 0%, #0a101f 100%);
              }
              &:nth-child(2n + 2) {
                margin-right: 0;
              }
              .equip-info {
                width: 100%;
                color: #ffffff;
                font-size: 14px;
                .equip-state {
                  font-size: 12px;
                  margin-top: 10px;
                  span.count {
                    color: #01d4f9;
                    font-size: 24px;
                  }
                }
              }
            }
            &::-webkit-scrollbar {
              width: 0 !important;
            }
          }
        }
        .right-containerOur {
          height: 100%;
          width: calc(100% - 382px);
          display: flex;
          .right-container {
            // float: right;
            margin-left: 5px;
            width: 50%;
            height: calc(100% - 30px);
            .statistical-container {
              width: 100%;
              height: 100%;
              .top-container {
                border: 1px solid #369aff;
                background: rgba(0, 186, 255, 0.1);
                height: 145px;
                margin-bottom: 5px;
                .device-item {
                  float: left;
                  width: 20%;
                  height: 100%;
                  text-align: center;
                  cursor: pointer;
                  .device-icon {
                    width: 48px;
                    height: 48px;
                    margin: 10px auto 12px;
                    background-position: center;
                    background-size: cover;
                  }
                  .device-tip {
                    color: #01d4f9;
                    margin-bottom: 10px;
                  }
                  .device-count {
                    color: #ffffff;
                    font-size: 36px;
                    font-weight: bold;
                  }
                  &:hover {
                    opacity: 0.7;
                  }
                }
              }
              .bottom-container {
                border: 1px solid #369aff;
                background: rgba(0, 186, 255, 0.1);
                height: calc(100% - 155px);
                /deep/ .el-carousel {
                  height: 100%;
                  .el-carousel__container {
                    height: 100%;
                    .el-carousel__item {
                      padding: 10px;
                      div.title {
                        font-weight: normal;
                        color: #01d4f9;
                        font-size: 18px;
                        text-align: left;
                        span {
                          height: 20px;
                        }
                        i.square {
                          display: inline-block;
                          width: 12px;
                          height: 18px;
                          background: #01d4f9;
                          margin-right: 10px;
                          vertical-align: middle;
                        }
                        i.circle {
                          display: inline-block;
                          border-radius: 50%;
                          width: 16px;
                          height: 16px;
                          background: #00cc35;
                          margin-left: 10px;
                          margin-bottom: 4px;
                          vertical-align: middle;
                          &.error {
                            background: #fc010d;
                          }
                        }
                        span.fr {
                          b {
                            font-weight: normal;
                            margin-left: 20px;
                            font-size: 14px;
                            color: #fff;
                            &:first-child {
                              color: #00cc35;
                            }
                            &.error {
                              color: #fc010d;
                            }
                          }
                        }
                      }
                      .wuhongwai {
                        display: flex;
                        justify-content: space-around;
                        .span {
                          float: none;
                        }
                      }
                      div.detail {
                        padding: 10px 0 0;
                        span {
                          float: left;
                          width: 20%;
                          text-align: center;
                          font-size: 16px;
                          margin-bottom: 10px;
                          div:first-child {
                            color: #ffffff;
                            margin-bottom: 10px;
                            &.error {
                              color: #fc010d;
                            }
                          }
                          div:last-child {
                            color: #01d4f9;
                            overflow: hidden;
                            white-space: nowrap;
                          }
                          &.filter-gray {
                            div {
                              color: #999;
                            }
                          }
                        }
                        &.row2 {
                          span {
                            font-size: 14px;
                          }
                        }
                      }
                      .fred {
                        color: #fc010d;
                        font-size: 18px;
                        text-align: center;
                        padding-top: 20px;
                        div {
                          margin-bottom: 20px;
                          span {
                            margin-left: 20px;
                          }
                        }
                      }
                      .horizontal-line {
                        position: relative;
                        width: 100%;
                        margin: 20px 0;
                        height: 2px;
                        &::before {
                          content: "";
                          position: absolute;
                          background-image: linear-gradient(
                            to left,
                            #57c7ed,
                            transparent
                          );
                          left: 10%;
                          right: 50%;
                          height: 2px;
                        }
                        &::after {
                          content: "";
                          position: absolute;
                          background-image: linear-gradient(
                            to right,
                            #57c7ed,
                            transparent
                          );
                          left: 50%;
                          right: 10%;
                          height: 2px;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          .right-container0 {
            // float: right;
            width: 50%;
            height: 100%;
            margin-left: 5px;
            .statistical-container {
              width: 100%;
              height: calc(100% - 30px);
              .bs {
                &:hover {
                  opacity: 0.7;
                }
                border: 1px solid #369aff;
                background: rgba(0, 186, 255, 0.1);
                height: 194px;
                margin-bottom: 5px;
                padding: 20px 20px;
                .bs-icon {
                  display: inline-block;
                  width: 17px;
                  height: 17px;
                  // margin: 10px auto 12px;
                  background-size: cover;
                }
                .bs-icon2 {
                  margin-left: 5px;
                  display: inline-block;
                  width: 218px;
                  height: 10px;
                  background-size: cover;
                }
                .square {
                  display: inline-block;
                  width: 12px;
                  height: 18px;
                  background: #01d4f9;
                  margin-right: 10px;
                  vertical-align: middle;
                }
                .bs-name {
                  align-items: center;
                  margin-left: 8px;
                  margin-bottom: 15px;
                  display: inline-block;
                  color: #01d4f9;
                  font-size: 18px;
                  font-weight: 600;
                }
                .bs-wcl {
                  display: inline-block;
                  margin-left: 5px;
                }
                .bs-bt {
                  width: 100%;
                  // display: flex;
                  height: calc(100% - 53px);
                  // justify-content: space-between;
                  .echart-yuan {
                    border-radius: 50%;
                    width: 7px;
                    display: inline-block;
                    height: 7px;
                  }
                  .zongdanshu-bg {
                    background-color: #faaa01;
                  }
                  .zongdanshu-color {
                    color: #faaa01;
                    font-weight: bolder;
                  }
                  .wanchengdanshu-bg {
                    background-color: #00a3fc;
                  }
                  .wanchengdanshu-color {
                    color: #00a3fc;
                    font-weight: bolder;
                  }
                  .zhixingzhong-bg {
                    background-color: #0afbbd;
                  }
                  .zhixingzhong-color {
                    color: #0afbbd;
                    font-weight: bolder;
                  }
                  .wanchenglv-bg {
                    background-color: #aed7fe;
                  }
                  .wanchenglv-color {
                    color: #aed7fe;
                    font-weight: bolder;
                  }
                }
              }
              .xj {
                &:hover {
                  opacity: 0.7;
                }
                border: 1px solid #369aff;
                background: rgba(0, 186, 255, 0.1);
                height: 194px;
                margin-bottom: 5px;
                padding: 20px 25px;
                .xj-icon {
                  display: inline-block;
                  width: 17px;
                  height: 17px;
                  // margin: 10px auto 12px;
                  background-size: cover;
                }
                .xj-icon2 {
                  margin-left: 5px;
                  display: inline-block;
                  width: 218px;
                  height: 10px;
                  background-size: cover;
                }
                .xj-name {
                  align-items: center;
                  margin-left: 8px;
                  margin-bottom: 15px;
                  display: inline-block;
                  color: #01d4f9;
                  font-size: 18px;
                  font-weight: 600;
                }
                .square {
                  display: inline-block;
                  width: 12px;
                  height: 18px;
                  background: #01d4f9;
                  margin-right: 10px;
                  vertical-align: middle;
                }
                .xj-wcl {
                  display: inline-block;
                  margin-left: 5px;
                }
                .xj-bt {
                  width: 100%;
                  // display: flex;
                  height: calc(100% - 53px);
                  // justify-content: space-between;
                  .echart-yuan {
                    border-radius: 50%;
                    width: 7px;
                    display: inline-block;
                    height: 7px;
                  }
                  .zongdanshu-bg {
                    background-color: #0bfbbe;
                  }
                  .zongdanshu-color {
                    color: #0bfbbe;
                    font-weight: bolder;
                  }
                  .wanchengdanshu-bg {
                    background-color: #50cdff;
                  }
                  .wanchengdanshu-color {
                    color: #50cdff;
                    font-weight: bolder;
                  }
                  .zhixingzhong-bg {
                    background-color: #00a3fc;
                  }
                  .zhixingzhong-color {
                    color: #00a3fc;
                    font-weight: bolder;
                  }
                  .wanchenglv-bg {
                    background-color: #aed7fe;
                  }
                  .wanchenglv-color {
                    color: #aed7fe;
                    font-weight: bolder;
                  }
                }
              }
              .yf {
                &:hover {
                  opacity: 0.7;
                }
                border: 1px solid #369aff;
                background: rgba(0, 186, 255, 0.1);
                height: calc(100% - 403px);
                margin-bottom: 5px;
                padding: 20px 25px;
                .yf-icon {
                  display: inline-block;
                  width: 17px;
                  height: 17px;
                  // margin: 10px auto 12px;
                  background-size: cover;
                }
                .yf-icon2 {
                  margin-left: 10px;
                  display: inline-block;
                  width: 218px;
                  height: 10px;
                  background-size: cover;
                }
                .square {
                  display: inline-block;
                  width: 12px;
                  height: 18px;
                  background: #01d4f9;
                  margin-right: 10px;
                  vertical-align: middle;
                }
                .yf-name {
                  align-items: center;
                  margin-left: 8px;
                  margin-bottom: 15px;
                  display: inline-block;
                  color: #01d4f9;
                  font-size: 18px;
                  font-weight: 600;
                }
                .yf-cszl {
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                  margin-bottom: 30px;
                }
                .yf-yczl {
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                }
              }
            }
          }
        }
      }
      .bottom-container-yctj {
        width: 90%;
        height: calc(100% - 640px);
        .echart-container {
          height: calc(100% - 30px);
        }
      }
    }
    .right-container {
      float: right;
      width: calc(24% - 27px);
      height: 100%;
      .table-container {
        height: calc(100% - 30px);
      }
      // .top-container0 {
      //   height: 300px;
      //   .business-item{
      //     border: 1px solid #369aff;
      //     background: rgba(0, 186, 255, 0.1);
      //     height: 80px;
      //     display: flex;
      //     .name-item{
      //       line-height: 80px;
      //       width: 20%;
      //       font-size: 18px;
      //       height: 100%;
      //       text-align: center;
      //       border-right: 1px solid #369aff;
      //     }
      //     .info-item{
      //       width: 80%;
      //       height: 100%;
      //       align-items: center;
      //       display: flex;
      //       justify-content:space-around;
      //       .info-num{
      //           text-align: center;
      //       }
      //     }
      //   }
      //   .mb5{
      //     margin-bottom: 10px;
      //   }
      // }
      .top-container-sbyxcs {
        width: 100%;
        height: 629px;
        // margin-bottom: 10px;
        .top {
          border: 1px solid #369aff;
          background: rgba(0, 186, 255, 0.1);
          height: 145px;
          margin-bottom: 5px;
          padding: 10px;
          &:hover {
            opacity: 0.7;
          }
          .elevator-monitoring {
            padding: 0 30px;
            display: flex;
            justify-content: space-between;
            .num-box {
              display: flex;
              flex-direction: column;
              img {
                width: 48px;
                text-align: center;
                margin-left: 3px;
              }
              .num-name {
                color: #01d4f9;
                margin-top: 14px;
              }
              .num-number {
                color: #ffffff;
                font-size: 32px;
                margin-top: 14px;
                text-align: center;
              }
            }
          }
        }
        .bottom {
          position: relative;
          border: 1px solid #369aff;
          background: rgba(0, 186, 255, 0.1);
          height: calc(100% - 155px);
          margin-bottom: 5px;
          padding: 10px;
          .bjxx-name {
            align-items: center;
            margin-left: 8px;
            display: inline-block;
            color: #01d4f9;
            font-size: 18px;
            font-weight: 600;
            .square {
              display: inline-block;
              width: 12px;
              height: 18px;
              background: #01d4f9;
              margin-right: 10px;
              vertical-align: middle;
            }
          }
          .list_dv {
            .scroll1 {
              border: 1px solid #369aff;
              margin-top: 10px;
              font-size: 14px;
              cursor: pointer;
            }
            height: calc(100% - 11px);
            overflow-y: auto;
            -ms-overflow-style: none; /* IE 和 Edge */
            scrollbar-width: none; /* 火狐 */
          }
          .list_dv::-webkit-scrollbar {
            display: none;
          }
        }
      }
      .bottom-container-bjts {
        float: right;
        width: 140%;
        height: calc(100% - 635px);
      }
    }
  }

  .title {
    position: relative;
    color: #ffffff;
    font-size: 16px;
    height: 30px;
    line-height: 30px;
  }

  /deep/ .el-table::before {
    height: 0px;
  }

  /deep/ .el-table {
    background: transparent;
    .el-table__body {
      tr:hover > td {
        color: #022d53;
        background: #a8e6f3;
      }
    }
    .el-table__header-wrapper {
      tr {
        background-color: transparent;
        th {
          color: #ffffff;
          background-color: rgba(0, 186, 255, 0.1);
          border: none;
          &.gutter {
            background: transparent;
          }
        }
      }
    }
    .el-table__body-wrapper {
      scrollbar-width: none;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
      tbody {
        tr {
          background: transparent;
          td {
            border: 1px solid #022d53;
            color: #a8e6f3;
          }
        }
      }
    }
  }
}
</style>
